module.exports = __webpack_public_path__ + "static/disabled.8ec3b75f.png";


//////////////////
// WEBPACK FOOTER
// ./src/examples/vampire-example/disabled.png
// module id = 1014
// module chunks = 13396140415750